export default "__VITE_ASSET__8aIzNs4K__"